
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Fügen Sie es zu Ihrem Startbildschirm hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
's1b9047d53d9f9d22': `2) Drücken Sie auf Teilen in der Navigationsleiste`,
's37a9e8aec5713460': `Mehr`,
's5c6aad7a7e4a1437': `3) Drücken Sie Hinzufügen zum Startbildschirm`,
's6196153c4b0c1ea0': `Installieren`,
's922329d6f6213590': `Zum Dock hinzufügen`,
'sa5ef80b4bb9b39f8': `Weniger`,
'sa7551383d1897fcc': `2) Drücken Sie auf Zum Dock hinzufügen`,
'sba52286c21552a4e': `Installieren Sie es auf Ihrem Gerät für eine umfassende Erfahrung und einen leichten Zugriff.`,
'sc79fd7641eb9a975': `Anleitung ausblenden`,
'scdaf4bbff76674c8': `Hinzufügen zum Startbildschirm`,
'sdfe23506a3b0cdc8': `1) In Safari-Browser öffnen`,
'se740f75b95a51807': `Fügen Sie es zu Ihrem Dock hinzu, um eine umfassende Erfahrung und einen leichten Zugriff zu erhalten.`,
'sfea652f6580ff086': `Diese Website verfügt über App-Funktionalität.`,
    };
  